import Constant from "@constant/index.js";
import Intercept from "@observer/Intercept.js";
import {$util,$cookie} from "@util/util.js";
import Alert from "@util/alert.js";
import ViewTool from "./viewTool.js";
import BaseView from "@core/View.js";
import API from "@api/index.js";
import useDiscountDetailsStore from "@shared/store/useDiscountDetailsStore";
import Toast from '@/components/Toast';

export default class MainSkuView extends BaseView{
    constructor(model) {
        super(model);
        this._model = model;
        this._model._view = this;

        //mainsku的容器
        this._el = null;
        //整个mainsku的容器（不同于group，主要为了区分满减-多个mainsku）
        this._fullMainSkuEl = null;

        this._headerBoxEl = null;
        this._extraBoxEl = null;
        // 私人订制
        this._exPersonalBoxEl = null;
        this._packageBoxEl = null;
        //选择服务弹框
        this._serverBoxEl = null;
        //选择选件弹窗
        this._optionBoxEl = null;
        // 选择优惠券弹框
        this._couponBoxEl = null;
        // 到货通知弹框结构
        // this._arrivalBoxEl = null;
        // 全局定时器
        this.timer = null;
        //单品 --> mainSku._parent._headerBoxEl
        //套餐 --> mainSku._parent._headerBoxEl
        //选件 --> mainSku._parent._headerBoxEl
        //满减 --> mainSku._headerBoxEl

        this._addEl = null;
        this._reduceEl = null;
        this._eventCenter = new MainSkuEvent();
    }

    getAddPrice() {
        //套餐不用显示比价
        if (this._model._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE) {
            return "";
        }

        //预售定金不用显示比价
        if (this._model._booking &&  this._model._booking._presellway == 2) {
            return "";
        }
        //失效商品
        if(this._model._parent._invalid){
            return ``; 
        }
        if (this._model._addPrice && this._model._invalid == false) {
            return `<p class="le_marginl_31 le_tip_btn_border"><span tag='mainsku_addprice'>${this._model._addPrice}<span></p>`;
        }
        return "";
    }

    getCheckbox() {
        let arrChecked = false
        //套餐主品没有checkbox
        if (this._model._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE) {
            return "";
        }
        //失效商品
        if(this._model._invalid){
            return `<i class="iconfont icon-disabled item_checkbox"></i>`; 
        }
        //有效商品，但是无法选中
        if(this._model._purchaseEnable == false && this._model._invalid == false){
            return `<i class="iconfont icon-disabled item_checkbox"></i>`; 
        }
        // this._model._gift&&this._model._gift._data.map((item, index) => {
        //     if(item.stock >= 1 && item.stock < this._model._count){
        //         arrChecked = true
        //     }
        // })
        if (this._model._isChecked) {
            return `<i tag='setActive' leclick='onClickActive' class="iconfont icon-checked item_checkbox"></i>`;
        }else {
            return `<i tag='setActive' leclick='onClickActive' class="iconfont icon-uncheck item_checkbox"></i>`;
        }
        
    }

    getReduceBtnDisabled() {
        if (this._model._count == 1) {
            return "disabled";
        }
        return "";
    }

    getMaxBtnDisabled() {
        if (this._model._count >= this._model.getMaxBuyCount()) {
            return "disabled";
        }
        return "";
    }

    getInvalidSpanMsg(){
        if(this._model._invalid){
            if(this._model._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE){
                return "";
            }
            if(window._shopId == 1){
                return `<p class="le_tip_btn_right_angle find_similar" leclick='onClickSimilarity' tag='getSimilarity'>找相似<i class="iconfont le_vertical_align_m icon-arrow-down"></i></p>`;
            }else{
                return "";
            }
        }
        return "";
    }

    getMainSkuImg() {
        let html = "";
        if (!this._model._invalid) {
            html = `<div class="fl i_img">
                    <a href="${this._model._link}" target="_blank">
                        <img tag='mainsku_img' class='mainsku_thumbnail_img' src="${this._model._img}" alt="">
                    </a>
                </div>`
        } else if(this._model._price == "暂无报价"){
            html = `<div class="fl i_img">
            <img src="${this._model._img}" alt="">
            <div class="already_sold_box">
            <p class="sold_texts"></p>
            ${this.getInvalidSpanMsg()}
            </div>
            <div class="find_similar_dialog">
          </div>
        </div>`;
        }else {
           
            let msg = this._model.getInvalidMsg();
            if(msg){
                html = `<div class="fl i_img">
                <img src="${this._model._img}" alt="">
                <div class="already_sold_box">
                <p class="sold_text">${msg}</p>
                ${this.getInvalidSpanMsg()}
                </div>
                <div class="find_similar_dialog">
              </div>
            </div>`;
            }else{
                html = `<div class="fl i_img">
                <img src="${this._model._img}" alt="">
                <div class="already_sold_box">
                <p class="sold_texts"></p>
                ${this.getInvalidSpanMsg()}
                </div>
                <div class="find_similar_dialog">
              </div>
            </div>`;
            }
           
        }
        return html;
    }
    
    interceptList() {
        //image
        let imgEl = $(this._el).find("[tag=mainsku_img]");
        new Intercept().init(imgEl, this._model, "_img");
        //name
        let nameEl = $(this._el).find("[tag=mainsku_name]");
        new Intercept().init(nameEl, this._model, "_name");
        //addprice
        let addpriceEl = $(this._el).find("[tag=mainsku_addprice]");
        new Intercept().init(addpriceEl, this._model, "_addPrice");
        //count
        let countEl = $(this._el).find("[tag=mainsku_count]");
        new Intercept().init(countEl, this._model, "_count");
        //total
        let totalPriceEl = $(this._el).find("[tag=mainsku_totalprice]");
        // 预售有定金抵扣时小计特殊处理
        // if(!(this._model._booking && this._model._booking._presellway == 2)){
            new Intercept().init(totalPriceEl, this._model, "_totalPrice");
        // }
        //checked
        let checkedEl = $(this._el).find("[tag=setActive]");
        let checkedIntercept =  new Intercept();
        checkedIntercept.init(checkedEl, this._model, "_isChecked", 'cls',"icon-checked","icon-uncheck")
        // Background
        // 满减之外的其他类型商品的header在group上
        let backGrounddEl = $(this._model._parent._view._el).find("div[iddf='"+this._model._itemId+"'][tag=setGroupBackground]");
        // new Intercept().init(backGrounddEl, this._model, "_isChecked", 'cls');
        if(backGrounddEl){
            checkedIntercept.addObserver(backGrounddEl,'cls',"active");
        }
        
        
        // 满减商品行的header在主品自身上
        if (this._model._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE){
            let headBoxEl = $(this._model._parent._view._el).find(`[tag='mainsku_head_box_background_tag'][iddf='${this._model._itemId}']`);
            checkedIntercept.addObserver(headBoxEl,'cls',"active");
            backGrounddEl = $(this._model._parent._view._el).find("div[iddf='"+this._model._itemId+"'][tag=setBackground]");
            if(backGrounddEl){
                checkedIntercept.addObserver(backGrounddEl,'cls',"active");
            }
        }else{
            // 满减之外的其他类型商品的header在group上
            let headBoxEl = $(this._model._parent._view._el).find("[tag=group_head_box_background_tag]");
            if(headBoxEl){
                checkedIntercept.addObserver(headBoxEl,'cls',"active");
            }

        }
        
        //_purchaseMsg
        let purchaseMsg = $(this._el).find("[tag=mainsku_purchaseMsg]");
        new Intercept().init(purchaseMsg, this._model, "_purchaseMsg");
        //_hasCoupons
        let Coupon = $(this._el).find("[tag=mainskuSelectCoupon]");
        new Intercept().init(Coupon, this._model, "_hasCoupons", 'show');
        //_hasServices
        let Services = $(this._el).find("[tag=mainskuSelectService]");
        new Intercept().init(Services, this._model, "_hasServices", 'show');   
        
        const goodsDeliveryPriceEl = $(this._el).find("[tag=goodsDeliveryPrice]");
        if(goodsDeliveryPriceEl) {
          new Intercept().init(goodsDeliveryPriceEl, this._model, "_deliveryPrice");   
        }

    }

    isPackage() {
        return this._model._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE ? 'hidden' : "visible";
    }

    getPriceAndTotalPrice(){
        // 单价使用le_paddingl_31 总计使用le_paddingl_65才能对齐
        let res = {price:"", total:""};
        // 单价
        res.price = `<p style="opacity:${(this._model._invalid ) ? '0.5' : '1'};visibility:${this.isPackage()};" class="le_paddingl_31"><span>￥${this._model._price}</span></p>
            ${this.getAddPrice()}`;
        // 预售有定金抵扣时小计特殊处理
        if((this._model._booking && this._model._booking._deduction == '待公布')) {
            res.total = `<p style="opacity:${(this._model._invalid ) ? '0.5' : '1'};visibility:${this.isPackage()};"  class="le_paddingl_65"><span ></span><span tag='mainsku_totalprice'>￥${this._model._totalPrice}</span></p>`;
        } else {
            if(this._model._booking && this._model._booking._presellway == 2){
                res.total = `<p style="opacity:${(this._model._invalid ) ? '0.5' : '1'};visibility:${this.isPackage()};"  class="le_paddingl_65"><span >定金¥</span><span tag='mainsku_totalprice'>${this._model._totalPrice}</span></p>`;
            }else{        
                res.total = `<p style="opacity:${(this._model._invalid ) ? '0.5' : '1'};visibility:${this.isPackage()};" class="le_paddingl_65"><span >¥<span tag='mainsku_totalprice'>${this._model._totalPrice}</span></span></p>`;
            }
        }
        
        
        return res;
    }

    getCountBtn() {
        //套餐
        if (this._model._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE) {
            return `<div  class="fl le_width_172 i_quantity">1件/套 x <span tag='mainsku_count'>${this._model._count}</span></div>`;
        }
        //失效商品不显示按钮
        if(this._model._invalid){
            return "";
        }
        if(this._model._purchaseEnable == false){
            return `<input type="button" disabled value="-" class="reduce">
            <input class="num" disabled value="${this._model._count}" type="text">
            <input type="button" disabled value="+" class="add">`;
        }
        //其他
        return `<input type="button" ${this.getReduceBtnDisabled()} value="-" tag='mainskureduce' class="reduce" leclick='onClickReduce'>
            <input class="num" tag='mainsku_count' leblur='onBlurCount' value="${this._model._count}" type="text">
            <input type="button" ${this.getMaxBtnDisabled()} value="+" tag='mainskuadd' class="add" leclick='onClickAdd'>`;
    }

    getFavOrNoticeBtn(){
        //下架
        if(this._model._marketable == false || (this._model._price == "暂无报价")){
            return "";
        }
        //没有库存
        if(this._model._stock <= 0 ){
            return `<button leclick='onClickNotice'>到货提醒</button>`;
        }
        //收藏夹
        return `<button leclick='onClickFav'>移入收藏夹</button>`;
    }
    // 价格附注信息
    handlePriceRemarks(){
      const {
        subsidyPreIndex = '',
        subsidyCheckItemDesc = '',
        deliveryPricePreIndex = '',
        deliveryPrice = '',
      } = this._model._data;
      const { _deliveryPrice } = this._model;
      /* 
        有下单立减优惠或者优惠券优惠的国补品未选：展示“预估国补后xx元”
        有下单立减优惠或者优惠券优惠的国补品且是单品单选：展示“预估到手价xx元”
        有下单立减优惠或者优惠券优惠的国补品多品或多选：展示“国家补贴，至高减xx%”
        无下单立减优惠或者优惠券优惠的国补品未选：展示“预估国补后xx元”
        无下单立减优惠或者优惠券优惠的国补品单选：展示“国家补贴，至高减xx%”
        无下单立减优惠或者优惠券优惠的国补品多选：展示“国家补贴，至高减xx%”
      */
      const htmlKey = [
        { condition: subsidyPreIndex, value: 'subsidyPreIndex' },
        { condition: subsidyCheckItemDesc, value: 'subsidyCheckItemDesc' },
        { condition: deliveryPricePreIndex && !subsidyPreIndex && !subsidyCheckItemDesc, value: 'deliveryPricePreIndex' },
      ].find(item => item.condition)?.value || '';
      const remarksHtml = {
        subsidyPreIndex: `<div class="le_paddingl_31 goodsDeliveryPriceWrapper le_margint_6" style="color: #0F9B43;">${subsidyPreIndex}<span class="goodsDeliveryPrice" style="color: #E1140A;" tag="goodsDeliveryPrice">￥${_deliveryPrice}</span></div>`,
        subsidyCheckItemDesc: `<div class="le_paddingl_31 goodsDeliveryPriceWrapper le_margint_6" style="color: #0F9B43;">${subsidyCheckItemDesc}</div>`,
        deliveryPricePreIndex: `<div class="le_paddingl_31 goodsDeliveryPriceWrapper le_margint_6">${deliveryPricePreIndex}<span class="goodsDeliveryPrice" tag="goodsDeliveryPrice">￥${_deliveryPrice}</span></div>`,
      }
      // 没有对应字段 不展示价格附注信息
      return remarksHtml?.[htmlKey] || '';
    }

    render() {
        let parentEl = $(this._model._parent._view._mainSkuBoxEl);
        this._headerBoxEl = this._model._parent._view._headerBoxEl;
        this._extraBoxEl = this._model._parent._view._extraBoxEl;
        this._exPersonalBoxEl = this._model._parent._view._exPersonalBoxEl;
        const goodsPresellType = this._model && this._model._data && this._model._data.presellType; // 商品预售类型  普通预售：0  候补：1
        let tmpId = this._model._id + '_' + (this._model._parent._itemId == "" ? this._model._itemId:this._model._parent._itemId);        
        let sku ='';
        if(this._model._isHours){
            sku += `
            <div class="xiaoshidaWrap" style="display: block;">
                <i class="xiaoshida_sanjiaoIcon"></i>
                <div class="xiaoshidaQrCodeBox" >                    
                </div>
            </div>
            `;
        }
        sku += `<!-- checkbox -->
        <div class='clearfix form' skuid=${tmpId}>
            <div class="fl i_checkbox">
                ${this.getCheckbox()}
            </div>
            <div class="fl i_checkboxs">
            </div>
            <!-- img -->
            ${this.getMainSkuImg()}
            <!-- MainSku desc -->
            <div class="fl i_desc">
                <h3 tag='mainsku_name' style="opacity:${(this._model._invalid ) ? '0.5' : '1'};"><a href="${this._model._link}" class="goods_selltype" preselltype=${goodsPresellType} target="_blank">${this._model._name}</a></h3>
                <ul class="desc_ul clearfix" style='visibility:${this._model._invalid ?'hidden':'visible'}'>                    
                    <li class="fl service_wrapper" style='display:${this._model._hasServices ?'block':'none'}'  tag='mainskuSelectService'>
                        <button class="le_color_red" leclick='onClickChSerivce' tag="onClickChSerivce">
                        ${this._model._service && this._model._service._data.length > 0 ? '<span>修改服务</span>' : '<span>选择服务</span>'}<i class="iconfont icon-arrow-down le_vertical_align_m"></i>
                        </button>
                        <div class="li_info service_box">                            
                        </div>
                    </li>
                    <li class="fl option_wrapper" style='display:${this._model._hasOptions ?'block':'none'}'  tag='mainskuSelectOption'>
                        <button class="le_color_red" leclick='onClickChOption' tag="onClickChOption">
                        ${this._model._option && this._model._option._data && this._model._option._data.length > 0 ? '<span>修改选件</span>' : '<span>选择选件</span>'}<i class="iconfont icon-arrow-down le_vertical_align_m"></i>
                        </button>
                        <div class="li_info option_box">                            
                        </div>
                    </li>
                    <li class="fl coupon_wrapper" style='display:none'  tag='mainskuSelectCoupon'>
                        <button class="le_color_red" leclick='onClickChCoupon' tag="onClickChCoupon">
                        领券<i class="iconfont icon-arrow-down le_vertical_align_m"></i>
                        </button>
                        <div class="li_info coupon_box">
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 价格 -->
            <div class="fl le_width_172 i_price" >
                ${this.getPriceAndTotalPrice().price}
                ${this.handlePriceRemarks()}
            </div>
            <!-- 库存 -->
            <div class="fl le_width_172 i_quantity" style="opacity:${(this._model._invalid ) ? '0.5' : '1'};">
                <p class="le_num_action">
                    ${this.getCountBtn()}
                </p>`;
            //套餐的限购提示放在header里面
            if (this._model._parent._itemType != Constant.GROUP_TYPE.PACKAGE.TYPE) {
                sku +=  `<p class="le_color_red limit_tip" tag='mainsku_purchaseMsg'>${(this._model._invalid) || (this._model._purchaseEnable == false && this._model._invalid == false) ? '' : this._model._purchaseMsg}</p>`;
            }

            sku += `</div>
            <!-- 小计 -->
            <div class="fl le_width_172 i_sum">
                ${this.getPriceAndTotalPrice().total}
            </div>
            <!-- 操作 -->
            <div class="fl le_width_116 i_action" style="visibility:${this.isPackage()}">
                ${this.getFavOrNoticeBtn()}
                <button leclick='onClickRemove' tag='removeMainSku'>删除</button>
            </div>
        </div>`;
        if (this._model._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE) {
            sku = `<div class='content_item ${this._model._isChecked ?'active':''}' tag="setBackground" iddf="${this._model._itemId}">
                    <div class='good_item_head_box  ${this._model._isChecked ?'active':''} promotion' iddf="${this._model._itemId}" tag="mainsku_head_box_background_tag"></div>
                   
                    <div class='good_main'>                        
                        ${sku}
                        <div class='extra extraCls'></div>
                    </div>
                </div>`;
        }
        parentEl.append($(sku));
        this._el = $("div[skuid='" + tmpId + "']");
        this._extraBoxEl = this._el.parents('div.content_item').find('.extraCls');
        this._exPersonalBoxEl = $('.personal_box')
        this._serverBoxEl = this._el.find('div.service_box');
        this._optionBoxEl = this._el.find('div.option_box');
        this._couponBoxEl = this._el.find('div.coupon_box');
        this._couponapplyBoxEl = this._el.find('div.apply_goods_box');
        // this._arrivalBoxEl = $('div.subscribe_mask');
        //满减
        if (this._model._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE) {
            this._fullMainSkuEl = this._el.parent('div.good_main');
        }
        if (this._model._parent._itemType == Constant.GROUP_TYPE.FULL_REDUCE.TYPE) {
            this._headerBoxEl = this._el.parents('div.content_item').find('.promotion');
        }
        //套餐容器
        if (this._model._parent._itemType == Constant.GROUP_TYPE.PACKAGE.TYPE) {
            this._packageBoxEl = this._el.parents('div.content_item').find('.packageBox');
        }
        //检查主品是否可用
        if (this._model._invalid) {
            if (this._model._parent._itemType != Constant.GROUP_TYPE.FULL_REDUCE.TYPE) {
                this._model._parent._view._el.addClass('alreadly_sold');
            } else {
                this._el.parents('div.content_item').addClass('alreadly_sold');
            }
        }
        this._addEl = $(this._el).find("input[tag='mainskuadd']");
        this._reduceEl = $(this._el).find("input[tag='mainskureduce']");
        useDiscountDetailsStore()?.setModel(this)

        this.interceptList();
        this.regEvent();
        this.registerEvent();
    }

    clearExtraBox() {
        this._packageBoxEl && this._packageBoxEl.html("");
        this._extraBoxEl && this._extraBoxEl.html("");
    }

    renderSimilarity(that){
        let data = this._model._similarityGoods._similaritygoods;
        let html = ''
        if(data && data instanceof Array && data.length > 0) {
            data.forEach(x => {                
                html += `<dl class="clearfix" >
                <dt class="fl">
                     <a href="${x.url.pc}" target="_blank" latag="latag_pc_cartOfflineGoods_recommendItem_${x.position}_${x.strategy}_${x.goodsCode}">
                        <img src="${x.thumbnail}" alt="">
                    </a>
                </dt>
                <dd class="fl">
                  <h5><a href="${x.url.pc}" target="_blank" latag="latag_pc_cartOfflineGoods_recommendItem_${x.position}_${x.strategy}_${x.goodsCode}">${x.name}</a></h5>
                  
                  <p class="clearfix add_cart" >               
                    <span class="fl">¥${x.price.P_C.C_1.P_0.DV.V}</span>
                    <i class="fr iconfont icon-rmd-cart" data-goodscode="${x.goodsCode}"></i>
                  </p>
                </dd>
              </dl>`
            });
            // <p class="comments">已有<span>36859</span>人评论</p>
            that._el.find('div.find_similar_dialog').html(html);
               
        } else {
            that._el.find('div.find_similar_dialog').html('<p style="position:relative;top:-12px;text-align: center;color: #716c6c;">暂无相似商品</p>');
        }
        
        
    }
    

    regEvent(){
        let that= this;

        that._el.off("click", "p.add_cart").on("click", "p.add_cart",function(e){
            let codes = $(e.target).data("goodscode")
            let _params ={               
                itemtype: 0, //0 单品, 2 选件, 3套餐 找相似只能加入单品
                gcodes: codes,//$(e.target).data("goodscode"),
                icount:1
            }
            that._model.addGoodsToCard(_params).then(x=>{
                that._el.find('div.find_similar_dialog').hide();   
                API.getCart().then(x=>{
                    _engine._currentTime = x.t.timestamp;
                    const nowDate = new Date();
                    //客户本地时间与服务器时间的差值
                    _engine._timeDiff = _engine._currentTime - nowDate.getTime();
                    _engine.reRenderCart(x.t);
                    _engine._price.init(x.t);
                    _engine._price._view.render();
                })        
            }).catch(err => {
                Alert.showTip(err.msg);
            });
        });
        // 点击body空白区域
        $('body').click(function(e){
            // $('div.service_box').hide(); 
            // $('div.coupon_box').hide();   
            var _ser = $('div.service_box');   // 设置目标区域
            var _cou = $('div.coupon_box');
            var _opt = $('div.option_box'); 
            var _serbtn = $('[tag=onClickChSerivce]');
            var _conbtn = $('[tag=onClickChCoupon]');
            var _similar = $('div.find_similar_dialog');
            var _btnSimilar = $('p[tag=getSimilarity]');
            // 目前空白区域点击不包含服务和优惠券弹框和服务和优惠券button按钮还有找相似按钮和弹框
            if(!_ser.is(e.target) && _ser.has(e.target).length === 0 &&
             !_cou.is(e.target) && _cou.has(e.target).length === 0 && 
             !_serbtn.is(e.target) && _serbtn.has(e.target).length === 0 && 
             !_conbtn.is(e.target) && _conbtn.has(e.target).length === 0 && 
             !_similar.is(e.target) && _similar.has(e.target).length === 0 && 
             !_btnSimilar.is(e.target) && _btnSimilar.has(e.target).length === 0 &&
             !_opt.is(e.target) && _opt.has(e.target).length === 0 
             ){ 
                // 功能代码
                $('div.service_box').hide(); 
                $('div.coupon_box').hide();  
                $('div.option_box').hide();
                $('div.find_similar_dialog').hide();
                $('p[tag=getSimilarity] i.iconfont').removeClass('icon-arrow-up').addClass('icon-arrow-down');
                $('button[tag=onClickChCoupon]').parent('li').removeClass('active');
                $('button[tag=onClickChCoupon]').children('i').removeClass('icon-arrow-up').addClass('icon-arrow-down');
                $('button[tag=onClickChSerivce]').parent('li').removeClass('active');
                $('button[tag=onClickChSerivce]').children('i').removeClass('icon-arrow-up').addClass('icon-arrow-down');
                $('button[tag=onClickChOption]').parent('li').removeClass('active');
                $('button[tag=onClickChOption]').children('i').removeClass('icon-arrow-up').addClass('icon-arrow-down');

            }
        })
        
        
    }
}


class MainSkuEvent{
    //删除
    onClickRemove(sender, data){
        let that = data.view;
        Alert.showConfirm({
            title:"删除商品？",
            content:"您可以选择移入收藏夹、或删除商品",
            confirmText:"移入收藏夹",
            confirm:function(){
                //移入收藏夹
                that._model.addToFavorite().then(x => {
                    //检测购物车是否还有商品
                    _engine._price._view.checkCartEmpty();
                }).catch(err => { 
                    Alert.showTip(err);
                })
            },
            cancelText:"删除",
            cancel:function(){
                //删除
                that._model.removeMainSku().then(x => {
                    //检测购物车是否还有商品
                    _engine._price._view.checkCartEmpty();
                }).catch(err => {
                    Alert.showTip(err);
                });
            }
        })
    }
   
    // 选择服务
    onClickChSerivce(sender, data){ 
        let that = data.view;   
        let services = that._model._data.services;
        
        // let arr = [{id:"1000247"},{id:"1000248"}]
        // let as=[]
        // 每次点击都关闭所有的服务框,防止一个页面弹出多个服务弹窗, 会造成的问题是同时打开两个弹框, 关闭一个,就不能关闭第二个了 --di
        $('div.service_box').hide(); 
        $('div.coupon_box').hide();  
        $('div.option_box').hide();  
        $('button[tag=onClickChCoupon]').parent('li').removeClass('active');
        $('button[tag=onClickChCoupon]').children('i').removeClass('icon-arrow-up').addClass('icon-arrow-down');      
        $('button[tag=onClickChOption]').parent('li').removeClass('active');
        $('button[tag=onClickChOption]').children('i').removeClass('icon-arrow-up').addClass('icon-arrow-down');
        var iconfontDom = that._el.find("[tag=onClickChSerivce]").find('i.iconfont');
        if(iconfontDom.hasClass('icon-arrow-down')){
            // $("[tag=onClickChSerivce] i.iconfont").removeClass('icon-arrow-up').addClass('icon-arrow-down');
            // $("[tag=onClickChSerivce]").parent().removeClass("active");
            iconfontDom.removeClass('icon-arrow-down').addClass('icon-arrow-up');

            that._model.getServiceList(services).then(
                x=>{
                    that._model._serviceGoods._view.render();
                    that._el.find('div.service_box').show();  
                    that._el.find("[tag=onClickChSerivce]").parent().addClass("active");             
                }
            ).catch(err => { 
                Alert.showTip(err);
            });  
        }else{
            iconfontDom.removeClass('icon-arrow-up').addClass('icon-arrow-down')
            that._el.find('div.service_box').hide();
            that._el.find("[tag=onClickChSerivce]").parent().removeClass("active"); 
        }
           
        // if(that._model._serviceGoods && that._model._serviceGoods._serviceList && that._model._serviceGoods._serviceList.length > 0) {     
        //     that._el.find('div.service_box').show(); 
        // }else{            
        //     that._model.getServiceList().then(
        //         x=>{
        //             that._model._serviceGoods._view.render();
        //             that._el.find('div.service_box').show();                
        //         }
        //     ).catch(err => { 
        //         Alert.showTip(err);
        //     });              
        // }
    }
    onClickChOption(sender, data){ 
        let that = data.view;  

        $('div.service_box').hide(); 
        $('div.coupon_box').hide();  
        $('div.option_box').hide();  
        $('button[tag=onClickChCoupon]').parent('li').removeClass('active');
        $('button[tag=onClickChCoupon]').children('i').removeClass('icon-arrow-up').addClass('icon-arrow-down');
        $("button[tag=onClickChSerivce] i.iconfont").removeClass('icon-arrow-up').addClass('icon-arrow-down');
        $("button[tag=onClickChSerivce]").parent().removeClass("active");       ;
        var iconfontDom = that._el.find("[tag=onClickChOption]").find('i.iconfont');
        if(iconfontDom.hasClass('icon-arrow-down')){
            // $('div.option_box').hide();  
            // $('button[tag=onClickChOption]').parent('li').removeClass('active');
            // $('button[tag=onClickChOption]').children('i').removeClass('icon-arrow-up').addClass('icon-arrow-down'); 
            that._model.getOptionGoods().then(
                x=>{
                    that._model._optionList._view.render();
                    // that._model._serviceGoods._view.render();
                    that._el.find('div.option_box').show();  
                    iconfontDom.removeClass('icon-arrow-down').addClass('icon-arrow-up');
                    that._el.find("[tag=onClickChOption]").parent().addClass("active");             
                }
            ).catch(err => { 
                Alert.showTip("没有可用选件");
            });  
        }else{
            iconfontDom.removeClass('icon-arrow-up').addClass('icon-arrow-down');            
            that._el.find("[tag=onClickChOption]").parent().removeClass("active"); 
            that._el.find('div.option_box').hide();
        }
    }
    // 选择优惠券
    onClickChCoupon(sender, data){
        let that = data.view;
        var iconfontDom = that._el.find("[tag=onClickChCoupon]").find('i.iconfont');
        // 隐藏服务的弹框
        $('div.service_box').hide(); 
        $('div.coupon_box').hide();
        $('div.option_box').hide();
       
        $("button[tag=onClickChSerivce] i.iconfont").removeClass('icon-arrow-up').addClass('icon-arrow-down');
        $("button[tag=onClickChSerivce]").parent().removeClass("active");
        $('button[tag=onClickChOption]').parent('li').removeClass('active');
        $('button[tag=onClickChOption]').children('i').removeClass('icon-arrow-up').addClass('icon-arrow-down');
        // 隐藏适用商品的弹窗
        $('.coupon_wrapper .apply_goods_box').hide();  
        if(iconfontDom.hasClass('icon-arrow-down')){
            let iconParent = $('#cart_pc_wrapper').find("[tag=onClickChCoupon]").find('i.iconfont');
            iconParent.removeClass('icon-arrow-up').addClass('icon-arrow-down');
            $('#cart_pc_wrapper').find(".coupon_wrapper").removeClass("active");
            iconfontDom.removeClass('icon-arrow-down').addClass('icon-arrow-up');
            iconfontDom.parent().parent().addClass('active');
            that._el.find('div.coupon_box').html('');
                 
            that._model.getCouponList().then(
                x=>{
                    that._model._coupon._view.render();                    
                    that._el.find('div.coupon_box').show();                
                }
            );
          }else{
            iconfontDom.removeClass('icon-arrow-up').addClass('icon-arrow-down');
            iconfontDom.parent().parent().removeClass('active');
            that._el.find('div.coupon_box').hide();          
        }
        // if(that._model._coupon && that._model._coupon._coupons && that._model._coupon._coupons.length > 0) {     
        //     that._el.find('div.coupon_box').show();
        // }else{ 
        //     that._el.find('div.coupon_box').html('')           
        //     that._model.getCouponList().then(
        //         x=>{
        //             that._model._coupon._view.render();
        //             that._el.find('div.coupon_box').show();                
        //         }
        //     );
        // }
    }
    onClickSerivceItem(sender, data){
        let that = data.view;
    }
    //收藏夹
    onClickFav(sender, data){
        let that = data.view;
        Alert.showConfirm({
            title:"确认要将这1件商品移入收藏夹吗？",
            confirmText:"确定",
            confirm:function(){
                that._model.addToFavorite().then(x => {
                    //检测购物车是否还有商品
                    _engine._price._view.checkCartEmpty();
                }).catch(err => { 
                    Alert.showTip(err);
                })
            },
            cancelText:"取消",
            cancel:function(){}
        })
    }
    //到货提醒
    onClickNotice(sender, data){
        let that = data.view;        
        let _obj = [{
            linkAddress: that._model._link,
            code: that._model._id,
            name: that._model._name
        }];
        
        that._model.getArrival(_obj);
        that._model._arrivalGoods._view.render();
        $util.toggleBodyScroller(true);        
    }
    //减少数量
    onClickReduce(sender, data){
        let that = data.view;
        let count = parseInt(that._model._count) - 1;
        if (count < that._model.getMaxBuyCount()){ 
            that._addEl.removeAttr("disabled");
        }
        that._model.modifyCount(count).then(() => {
            if (count == 1) {
                $(sender).attr("disabled", true);
            }
        }).catch(err => { 
            Alert.showTip(err);
        });
    }
    //增加数量
    onClickAdd(sender, data){
        let that = data.view;
        that._reduceEl.removeAttr("disabled");
        let count = parseInt(that._model._count) + 1;
        that._model.modifyCount(count).then(() => {
            if (count >= that._model.getMaxBuyCount()) {
                $(sender).attr("disabled", true);
            }
        }).catch(err => { 
            Alert.showTip(err);
        });
    }
    //激活
    onClickActive(sender, data){
        let that = data.view;
        that._model.setActive().then().catch(err => { 
            Toast.once(err)
        });
    }
    //找相似
    onClickSimilarity(sender, data){
        let that = data.view;
        
        var iconfontDom = that._el.find("[tag=getSimilarity]").find('i.iconfont')
          if(iconfontDom.hasClass('icon-arrow-down')){
              // 隐藏其它找相似弹框
            $('.find_similar_dialog').hide();
            $('[tag=getSimilarity]').children('i').removeClass('icon-arrow-up').addClass('icon-arrow-down');
            iconfontDom.removeClass('icon-arrow-down').addClass('icon-arrow-up')
            that._el.find('div.find_similar_dialog').show();
            that._model.getSimilarityGoods().then((res)=>{
                that.renderSimilarity(that);
            }).catch(err => { 
                Alert.showTip(err);
            });
          }else{
            iconfontDom.removeClass('icon-arrow-up').addClass('icon-arrow-down')
            that._el.find('div.find_similar_dialog').hide();

          }
          $(this).parents('.already_sold_box').toggleClass('toggle_class')
          $(this).closest('.i_img').find('.find_similar_dialog').toggleClass('find_similar_toggle_class')
       
    }
    //修改数量
    onBlurCount(sender, data){
        let that = data.view;
        ViewTool.blurModifyCount(sender, that._addEl, that._reduceEl, that._model, that._model._count);
    }

    
}